import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import Navbar from '../../components/Navbar/Navbar';
import './About.css';
import Footer from '../Footer/Footer';
import Social from '../Social/Social';
import { db } from "../lib/init-firebase";
import loader from "../../images/Loading_icon.gif"
import { collection, getDocs } from "firebase/firestore";
import { Markup } from 'interweave';

const About = () => {

    const [aboutData, setAboutData] = useState({});

    useEffect(() => {
        const aboutRef = collection(db, "about");
        getDocs(aboutRef)
            .then((response) => {
                const about = response.docs.map((doc) => ({
                    data: doc.data(),
                }));
                setAboutData(about[0].data);
            })
            .catch((error) => console.log(error.message));
    }, []);

    const { description, education, skills } = aboutData

    if (Object.keys(aboutData).length === 0) {
        return (
            <>
                <Navbar />
                <div style={{ height: "100vh", backgroundColor: "#1A3D5D" }} className="d-flex justify-content-center align-items-center">
                    <img src={loader} width="100px" alt="" />
                </div>
            </>
        )
    }

    return (
        <div style={{ backgroundColor: "#1a3d5d", color: "white" }}>
            <Navbar />
            <div className="container">
                <div className="img-container text-center mt-5 pt-5">
                    <img width="250px" className="img-fluid about-pic" src={aboutData.img} alt="" />
                </div>
                <div className="details text-center">
                    <h1 className="heading pb-3 mt-3"><span style={{ borderBottom: '5px solid #0bc2c2' }} className="">I'm <span style={{ color: '#0bc2c2' }}>Roky Das</span></span></h1>
                    <p>{description}</p>
                </div>
                <div className="text-center">
                    <Social />
                </div>
                <div className="row mt-5 pt-5 mb-5">
                    <div className="col-md-6 skills-border">
                        <h1 className="heading text-center pb-3"><span style={{ borderBottom: '5px solid #0bc2c2' }} className="">My <span style={{ color: '#0bc2c2' }}>Skills</span></span></h1>
                        <ul>
                            {
                                skills?.map(skill => (
                                    <li>
                                        <h4 className="mt-3 mb-3" style={{ color: '#0bc2c2' }}>{skill.skillType}:</h4>
                                        {
                                            skill.skillList.map(skill => <h5 className="d-inline"><Badge className="mr-2 mb-1 p-2" variant="secondary">{skill}</Badge></h5>)
                                        }
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <h1 className="heading text-center pb-3"><span style={{ borderBottom: '5px solid #0bc2c2' }} className="">My <span style={{ color: '#0bc2c2' }}>Education</span></span></h1>
                        <ul>
                            {
                                education?.map(edu => (
                                    <li className="mt-3 mb-3">
                                        <h4 style={{ color: '#0bc2c2' }}>{edu.educationType}</h4>
                                        <Markup content={edu.educationDetails} />
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default About;